import { usePathAndData } from "../../../hook/usePathAndData";
import { AppLayout } from "../../layout/AppLayout";
import { ListaEmpresa } from "../../view/Empresa/ListaEmpresa";
import { PerfilEmpresa } from "../../view/Empresa/PerfilEmpresa/PerfilEmpresa";


export const PageEmpresa = () => {
    const { path, dataValue } = usePathAndData(); // Usa el hook

    return (
        <AppLayout>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="card">
                            <div className="card-body" style={{ borderRadius: "13px" }}>
                                {path[1] === "empresas" && path[2] === "lista" && <ListaEmpresa />}
                                {path[1] === "empresas" && path[2] === "perfil" && <PerfilEmpresa />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
};
